import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, fromEvent, merge, of, throwError, shareReplay } from 'rxjs';
import { map, mergeMap, startWith, tap } from 'rxjs/operators';
import { CONNECTION_ERROR_CODES } from '../../enums/connection-error-codes.enum';

@Injectable({
    providedIn: 'root',
})
export class ConnectivityService {
    // this is to set the sync indicator state correctly
    public isOnline$: Observable<boolean>;
    public isOnlineButWithErrors$: Observable<string>;
    public constructor(@Inject(LogInstanceToken) private readonly log: LogInterface) {
        this.isOnline$ = merge(
            fromEvent(window, 'online').pipe(map(() => true)),
            fromEvent(window, 'offline').pipe(map(() => false)),
        ).pipe(
            startWith(navigator.onLine),
            tap((value) => this.log.debug(`ConnectivityService : isOnline: ${value}`)),
            shareReplay(1),
        );

        this.isOnlineButWithErrors$ = this.isOnline$.pipe(
            mergeMap((online) =>
                online ? of('Internet') : throwError(() => CONNECTION_ERROR_CODES.NO_INTERNET_CONNECTION),
            ),
        );
    }

    /**
     * Check if internet connection is available using the cordova plugin $cordovaNetwork.
     * Immediately resolving for mock-mode.
     * Resolves with a string having a human readable text giving information about the connection type.
     */
    public isInternetConnectionAvailable(): boolean {
        return navigator.onLine;
    }
}
